<template>
  <div class="contactUs">
    <div class="contact_title">{{$t(`contactUs.contactUsTitle`)}}</div>
    <div class="content">
      <ul class="contentUl">
        <li class="contentLi" v-for="(item,index) in $t(`contactUs.contactUs`)" :key="index">
          <div class="content_img" :style="'background: url('+item.url+') center no-repeat'"></div>
         <div class="content_style">
					  <div class="content_name">{{item.name}}</div>
					 <div class="content_value">{{item.value}}</div>
				 </div>
          <div class="erweima"></div>
        </li>
      </ul>
    </div>
    <!-- 公司地址 -->
    <div class="address">
      <div class="map_left">
        <div id="allmap"></div>
      </div>
      <div class="map_right">
        <div class="right_warpper">
          <div class="map_top">
            <i class="icon"></i>
            <div class="map_title">{{$t(`contactUs.mapAddressTitle`)}}</div>
          </div>
          <div class="map_bottom">
            <div class="bottom_title">{{$t(`contactUs.map_address`)}}</div>
            <div class="bottom_address">{{content.address}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//引入底部子组件
import { MP } from '../../../static/js/map.js'
// import Banner from '../layout/banner'
export default {
   metaInfo: {
    title: '英特之家--金成英特教育', // set a title
    meta: [{                 // set meta
      name: '英特之家--金成英特教育'
    }]
  },
  name: 'contactUs',
  props: [],
  data () {
    return {
      ak: 'NsXKtvGd5DzXDR7thVIifGLqWP5wLX84',
      content: {}
    }
  },
  created () {

  },
  inject: ['reload'],
  mounted () {
    //type发生改变，向父组件传参
    if (this.$route.query.type) {
      this.$emit('typeChange', this.$route.query.type)
    }
    this.$nextTick(function () {
      var _this = this;
      MP(_this.ak).then(BMap => {
        //在此调用api
        _this.initMap();
      })
    })
    //获取公司信息
    getValue(this);
  },

  methods: {
    initMap () {
      //    以上是公共部分
      let map = new BMap.Map('allmap')
      var point = new BMap.Point(120.145734, 30.275245);
      map.centerAndZoom(point, 19);
      var marker = new BMap.Marker(point);  // 创建标注
      map.addOverlay(marker);               // 将标注添加到地图中;
      map.enableScrollWheelZoom(true);
      var polygon_nc = new BMap.Polygon([
        new BMap.Point(120.145244, 30.275316),
        new BMap.Point(120.146048, 30.275358),
        new BMap.Point(120.14625, 30.2753),
        new BMap.Point(120.146461, 30.274918),
        new BMap.Point(120.145339, 30.27484),
        new BMap.Point(120.145316, 30.274848),
        new BMap.Point(120.14524, 30.2753),

      ], { strokeColor: "#6ba9e5", fillColor: "#c7dff0", strokeStyle: "solid", strokeOpacity: "0.8", fillOpacity: "0.3", strokeWeight: "3" });
      map.addOverlay(polygon_nc);
    }
  },
}
function getValue (obj) {
  obj.$ajax('companyInfo/getCompanyInfo', 'get', {}, function (res) {
    let objData = res.data;
    obj.content = res.data;
    obj.$t(`contactUs.contactUs`)[0].value = objData.hotLine;
    obj.$t(`contactUs.contactUs`)[1].value = objData.email;
    obj.$t(`contactUs.contactUs`)[2].value = objData.weChat;
    // obj.$t(`contactUs.contactUs`)[3].value = objData.weChat;
  })
}
</script>

<style scoped="scoped">
.contact_title {
  height: 0.3rem;
  line-height: 0.3rem;
  font-size: 0.3rem;
  font-weight: bold;
  color: rgba(10, 80, 143, 1);
}
.content {
  margin-top: 1.36rem;
}
.contentUl {
  display: flex;
  justify-content: space-between;
}
.contentLi {
  text-align: center;
  min-width: 1rem;
  position: relative;
}
.content_img {
  height: 0.46rem;
  object-fit: cover;
}
.content_name {
  margin: 0.2rem auto 0.14rem;
  font-size: 0.18rem;
  height: 0.18rem;
  line-height: 0.18rem;
  font-weight: bold;
  color: rgba(63, 63, 63, 1);
}
.content_value {
  font-size: 0.14rem;
  height: 0.14rem;
  line-height: 0.14rem;
  font-weight: 400;
  color: rgb(26, 14, 14);
}
.contentLi:last-child .erweima {
  position: absolute;
	left: -1.1rem;
	top: 0.1rem;
  width: 1.02rem;
  height: 1.02rem;
	margin-left: 0.8rem;
  background: url(../../../static/img/constactUs.png) no-repeat;
  background-size: 100%;
  display: block;
}
.contentLi:last-child .content_style{
	margin-top: -0.25rem;
	margin-left: 0.8rem;
}
/* .contentLi:last-child:hover .erweima {
  display: block;
} */
.address {
  margin-top: 1.11rem;
  height: 3.19rem;
  width: 100%;
  border: 1px solid #dfe6ed;
}
#allmap {
  height: 3.19rem;
  width: 4.72rem;
}
.map_left {
  float: left;
}
.map_right {
  float: right;
  width: 3.17rem;
  height: 3.19rem;
  border-left: 1px solid #dfe6ed;
}
.right_warpper {
  margin: 0 0.28rem 0 0.35rem;
  height: 3.19rem;
  /* border: 1px solid red; */
}
.map_top {
  height: 0.91rem;
  border-bottom: 1px solid #dfe6ed;
  position: relative;
}
.map_top .icon {
  width: 0.28rem;
  height: 0.37rem;
  position: absolute;
  background: url('/static/img/contact_address.png') no-repeat;
  background-size: 100%;
  left: 0;
  top: 0.37rem;
}
.map_title {
  font-size: 0.17rem;
  height: 0.17rem;
  line-height: 0.17rem;
  font-weight: 400;
  color: rgba(10, 80, 143, 1);
  position: absolute;
  top: 0.5rem;
  left: 0.37rem;
}
.map_bottom {
  margin-top: 0.73rem;
  width: 2.38rem;
  overflow: hidden;
}
.bottom_title {
  font-size: 0.17rem;
  height: 0.17rem;
  line-height: 0.17rem;
  font-weight: bold;
  color: rgba(63, 63, 63, 1);
}
.bottom_address {
  margin-top: 0.2rem;
  font-size: 0.14rem;
  font-weight: 400;
  color: rgba(63, 63, 63, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/contactUs/contactUs.vue